import type { FC, ReactNode } from 'react'

import { ButtonLink } from '@/components/generals/button'
import { MediaImage } from '@/components/generals/media-image'

const PROMISES = [
    'Try pieces in your size, set aside for you before you arrive',
    'Gift preparation, engraving and personal wrapping',
    'Alterations and repairs carried out by our ateliers'
]

export const AppointmentTeaser: FC = (): ReactNode => {
    return (
        <section id='appointments' aria-labelledby='appointments-title' className='py-24 lg:py-36'>
            <div className='mx-auto grid max-w-[1600px] items-center gap-12 px-6 sm:px-10 lg:grid-cols-12 lg:gap-0 lg:px-16'>
                <div className='relative aspect-[4/5] overflow-hidden lg:col-span-6'>
                    <MediaImage
                        src='/images/home/boutique.jpg'
                        alt='A private salon in a Vaurel boutique with a green velvet sofa, a marble table and white flowers'
                        sizes='(min-width: 1024px) 50vw, 100vw'
                        className='object-cover object-[30%_50%]'
                    />
                </div>

                <div className='reveal lg:col-span-5 lg:col-start-8'>
                    <p className='eyebrow text-muted-foreground'>
                        Client services
                    </p>

                    <h2 id='appointments-title' className='mt-5 font-heading text-4xl font-light leading-[1.05] sm:text-5xl lg:text-6xl'>
                        A private appointment
                    </h2>

                    <p className='mt-6 text-[15px] leading-relaxed text-muted-foreground'>
                        Our client advisors welcome you in a private salon to discover the collections, try a piece or prepare a gift. Tell us what you would like to see and it will be waiting for you.
                    </p>

                    <ul className='mt-8 flex flex-col border-t border-border'>
                        {PROMISES.map(promise => (
                            <li key={promise} className='border-b border-border py-4 text-sm'>
                                {promise}
                            </li>
                        ))}
                    </ul>

                    <div className='mt-10 flex flex-wrap gap-3'>
                        <ButtonLink href='/appointment'>
                            Book an appointment
                        </ButtonLink>

                        <ButtonLink href='/boutiques' variant='outline'>
                            Find a boutique
                        </ButtonLink>
                    </div>
                </div>
            </div>
        </section>
    )
}
